const RIVER_API = 'https://us-central1-river-development-82310.cloudfunctions.net/app';
const RIVER_APP = 'https://river-development-82310.firebaseapp.com';
const SERVER_LOCAL_HOST = 'http://localhost:5001/river-development-82310/us-central1/app';
const CLIENT_LOCAL_HOST = 'http://localhost:3000';

export const serverConfig = process.env.NODE_ENV === 'production' ? RIVER_API : SERVER_LOCAL_HOST;
export const clientConfig = process.env.NODE_ENV === 'production' ? RIVER_APP : CLIENT_LOCAL_HOST;



// WEBPACK FOOTER //
// ./src/util/config.js